import React, { useEffect } from "react";
import "./HomeSection.css";

const HomeSection = () => {
  return (
    <div className="homeSection">
      <div className="text__div">
        <h1>
          Welcome to <br /> DAGA GROUP OF COMPANIES
        </h1>
        <h4>
          Welcome to Daga Group, a family-owned business with a proud 50-year
          plus legacy in the construction steel industry. Founded by two
          brothers in 1973, our Group has grown through hard work, integrity,
          and a commitment to quality. Over the years, we've built a reputation
          as the most trusted distributor of high-quality construction steel,
          serving projects of all sizes with reliability and expertise. As a
          second-generation business, our values remain deeply rooted in family.
          A few years ago, the next generation joined the business, with both of
          the founding brothers' sons bringing fresh perspectives and innovative
          ideas while continuing to honor the family values that have shaped our
          success. Today, we combine the wisdom and experience of two
          generations with the energy and vision of the next, ensuring that our
          commitment to quality, integrity, and customer satisfaction remains
          stronger than ever. At Daga Group, we pride ourselves on providing the
          highest standards in construction steel, ensuring that every delivery
          is timely and every product is reliable. With decades of experience
          and a family commitment to the industry, we are here to support your
          next project with the same dedication that has been our hallmark for
          over 5 decades. Thank you for visiting. We invite you to explore our
          range of products and services, and discover how our family can help
          yours build with confidence.
        </h4>
      </div>
      <div className="image__div">
        <img className="image__div___img" src="/images/image1.jpg" alt="img1" />
        <img
          className="image__div___img__bg"
          src="/images/image2.jpg"
          alt="img2"
        />
      </div>
    </div>
  );
};

export default HomeSection;
